const SECTION_KEYS = {
  'meeting purpose': 'meetingPurpose',
  'key takeaways': 'keyTakeaways',
  topics: 'topics',
  'next steps': 'nextSteps',
};

export function normalizeFathomMarkdown(text) {
  if (!text) return '';
  return String(text)
    .replace(/\\([<>])/g, '$1')
    .replace(/\r\n/g, '\n')
    .trim();
}

/**
 * Split Fathom markdown summary into named sections.
 * Returns { meetingPurpose, keyTakeaways, topics, nextSteps, hasStructuredSections }.
 */
export function parseFathomSummarySections(markdown) {
  const normalized = normalizeFathomMarkdown(markdown);
  const empty = {
    meetingPurpose: '',
    keyTakeaways: '',
    topics: '',
    nextSteps: '',
    hasStructuredSections: false,
  };

  if (!normalized) return empty;

  const sections = { ...empty };
  const lines = normalized.split('\n');
  let currentKey = null;
  const buffers = {
    meetingPurpose: [],
    keyTakeaways: [],
    topics: [],
    nextSteps: [],
    preamble: [],
  };

  for (const line of lines) {
    const h2Match = line.match(/^##\s+(.+?)\s*$/);
    if (h2Match) {
      const label = h2Match[1].trim().toLowerCase();
      currentKey = SECTION_KEYS[label] || null;
      if (currentKey) sections.hasStructuredSections = true;
      continue;
    }

    const target = currentKey || 'preamble';
    if (buffers[target]) {
      buffers[target].push(line);
    }
  }

  for (const key of Object.keys(SECTION_KEYS)) {
    const field = SECTION_KEYS[key];
    sections[field] = normalizeFathomMarkdown(buffers[field].join('\n'));
  }

  if (!sections.hasStructuredSections) {
    sections.keyTakeaways = normalized;
  } else if (buffers.preamble.length) {
    const preamble = normalizeFathomMarkdown(buffers.preamble.join('\n'));
    if (preamble && !sections.meetingPurpose) {
      sections.meetingPurpose = preamble;
    }
  }

  return sections;
}

export function formatActionItemsAsMarkdown(actionItems = []) {
  if (!actionItems.length) return '';
  const lines = actionItems
    .map((item) => {
      const text =
        typeof item === 'string' ? item : item?.description || item?.text || '';
      if (!text.trim()) return null;
      const assignee =
        typeof item === 'object' && item?.assigneeName
          ? ` (${item.assigneeName})`
          : '';
      return `- ${text.trim()}${assignee}`;
    })
    .filter(Boolean);
  return lines.join('\n');
}

function normalizeActionItemText(text) {
  return String(text || '')
    .trim()
    .toLowerCase()
    .slice(0, 300);
}

export function matchActionItemToTask(actionItem, tasks = []) {
  const description =
    typeof actionItem === 'string'
      ? actionItem
      : actionItem?.description || actionItem?.text || '';
  const normalized = normalizeActionItemText(description);
  if (!normalized) return null;

  return (
    tasks.find((task) => normalizeActionItemText(task?.title) === normalized) || null
  );
}
